@if (!!svgContent) {
  <div [innerHTML]="svgContent"></div>
}
@if (hasIcon) {
  <svg>
    <use [attr.href]="name"></use>
  </svg>
}
